import { createContext, useContext } from 'react';

/**
 * Bypass-only connector API exposed alongside the main AuthContext.
 * Null outside of dev bypass mode — LoginPage uses presence of this
 * context to decide whether to render dual connection paths.
 */
export interface BypassConnectors {
  /** Open our native EIP-6963 picker — no Privy SDK involvement. */
  connectInjected: () => void;
  /** Open Privy's picker (includes WalletConnect / mobile scan). */
  connectWalletConnect: () => void;
  /** true once Privy SDK finished bootstrapping. WalletConnect button is disabled until then. */
  privyReady: boolean;
}

export const BypassContext = createContext<BypassConnectors | null>(null);

export function useBypassConnectors(): BypassConnectors | null {
  return useContext(BypassContext);
}
